import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-gray-500 text-xs uppercase tracking-[0.3em]">
        Loading…
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
